<h3 translate>walk-step-biometrics.component.title</h3>
<lv-script-toggle>
  <p translate>walk-step-biometrics.component.script.intro</p>
  <p translate>walk-step-biometrics.component.script.outro</p>
</lv-script-toggle>
